"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidRoutingNumber = void 0;

var intAtIndex = function intAtIndex(value, index) {
  return Number.parseInt(value.charAt(index), 10);
};

var isValidRoutingNumber = function isValidRoutingNumber(value) {
  if (typeof value !== 'string' || value.length !== 9) return false;
  var x = 3 * (intAtIndex(value, 0) + intAtIndex(value, 3) + intAtIndex(value, 6));
  var y = 7 * (intAtIndex(value, 1) + intAtIndex(value, 4) + intAtIndex(value, 7));
  var z = intAtIndex(value, 2) + intAtIndex(value, 5) + intAtIndex(value, 8);
  var checksumTotal = x + y + z;
  return checksumTotal % 10 === 0;
};

exports.isValidRoutingNumber = isValidRoutingNumber;